import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectConnectedCrmOrgs,
  selectCrmOrgsAreReady,
} from '../components/pages/environments/environmentsReducer';
import useUserInfo from './useUserInfo';

export const useFetchPermissionsOnCrmOrgsChange = () => {
  const crmOrgs = useSelector(selectConnectedCrmOrgs);
  const crmOrgsAreReady = useSelector(selectCrmOrgsAreReady);
  const { getPermissions } = useUserInfo();
  const prevCrmOrgIdsRef = useRef<string[]>([]);
  const [initialPermissionsLoaded, setInitialPermissionsLoaded] = useState(false);

  useEffect(() => {
    if (!crmOrgsAreReady) {
      return;
    }

    const crmOrgIds = crmOrgs.map((org) => org.id);
    const prevIds = prevCrmOrgIdsRef.current;

    const hasChanged =
      crmOrgIds.length !== prevIds.length || crmOrgIds.some((id, i) => id !== prevIds[i]);

    if (!initialPermissionsLoaded) {
      getPermissions().then(() => {
        setInitialPermissionsLoaded(true);
      });
      prevCrmOrgIdsRef.current = crmOrgIds;
      return;
    }

    if (hasChanged && crmOrgIds.length > 0) {
      getPermissions();
      prevCrmOrgIdsRef.current = crmOrgIds;
    }
  }, [crmOrgsAreReady, crmOrgs, getPermissions, initialPermissionsLoaded]);

  return { initialPermissionsLoaded };
};
